import Image from 'next/image'

import { clsx } from 'clsx'

import { CSSProperties, FC, useEffect, useState } from 'react'

import { ExpressCourse } from '@/app/graphql/generated'
import { ListComponent } from '@/app/shared/components/list'
import { ImageLetsGo } from '@/app/shared/images'
import { clearList } from '@/app/shared/services/clearList'
import { t } from '@/core/lib/locale/i18n'

// interface
interface ICourseInfo {
  blockStyle: CSSProperties
  classNameColor: string
  data: ExpressCourse
}

// component
const CourseInfoComponent: FC<Readonly<ICourseInfo>> = ({ blockStyle, classNameColor, data }) => {
  const textColor = `text-${classNameColor}`

  const [listInfo, setListInfo] = useState<string[]>([])

  useEffect(() => {
    setListInfo(clearList(data.you_can ?? ''))
  }, [data.you_can])

  // return
  return (
    <div style={{ ...blockStyle }}>
      <div className={`mb-10 flex flex-wrap justify-between pr-9 ${textColor}`}>
        <h2 className={`text-[38px] font-extrabold`}>{data.title}</h2>
        <div className={'h-[62px] w-[90px] flex-shrink-0'}>
          <Image
            src={data?.sticker ?? ImageLetsGo}
            alt={'sticker'}
            width={90}
            height={90}
            className={'h-[90px] w-[90px] object-contain'}
            sizes={'(max-width:1028px):71px, (max-width:1600px):78px, 88px'}
          />
        </div>
      </div>
      {data?.long_description && (
        <div
          className={clsx(
            `mb-[30px] flex flex-col gap-2.5 text-[22px] text-black laptop:gap-5 [&_li]:grid [&_li]:grid-flow-row-dense [&_li]:grid-cols-[auto,1fr] [&_li]:gap-2.5 [&_li]:before:my-auto [&_li]:before:h-[26px] [&_li]:before:w-[26px] [&_li]:before:rounded-full [&_li]:before:bg-primary [&_li]:before:content-tick`,
            { '[&_li]:before:!bg-warning': classNameColor === 'warning' },
            { '[&_li]:before:!bg-success': classNameColor === 'success' },
            { '[&_li]:before:!bg-secondary': classNameColor === 'secondary' },
          )}
          dangerouslySetInnerHTML={{ __html: data.long_description }}
        />
      )}

      {listInfo?.length > 0 && (
        <div className={'mb-10 grid gap-5'}>
          <h3 className={'text-[24px] font-extrabold text-black'}>{t.you_can()}</h3>
          <ListComponent
            noAnimation
            data={listInfo}
            className={'grid text-black mobile:grid-cols-2'}
            colorIcon={classNameColor}
            editor
          />
        </div>
      )}
      {data?.prerequisite && (
        <div className={'grid gap-5 text-black'}>
          <h3 className={'text-[24px] font-extrabold'}>{t.prerequisite()}</h3>
          <span className={'text-[22px]'}>{data.prerequisite}</span>
        </div>
      )}
    </div>
  )
}

CourseInfoComponent.displayName = 'CourseInfoComponent'

export default CourseInfoComponent
